import { ReducersInterfaceAction } from "types/Reducers";
import { NavMenuConstants } from "../constants/constants";
import { NavMenuState } from "../types/NavMenu";
import { initialNavMenuState } from "store/initialStates";

export const navMenuReducer = (
  state = initialNavMenuState,
  action: ReducersInterfaceAction,
): NavMenuState => {
  switch (action.type) {
    case NavMenuConstants.TOGGLE_NAV_MENU:
      return {
        ...state,
        isOpen: action.payload,
      };
    default:
      return state;
  }
};
